import { render, staticRenderFns } from "./TinyReference.vue?vue&type=template&id=99524144"
import script from "./TinyReference.vue?vue&type=script&lang=js"
export * from "./TinyReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports